import { Drawer } from "components";
import {
  useGetHuduAuthConfig,
  useGlobalStore,
  useUpsertHuduAuthConfig,
} from "controller";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ConnectHuduAccount } from "./ConnectHuduAccount";
import { addMixpanelEvent } from "utilz/helpers";
import toast from "react-hot-toast";

interface HuduDrawerProps {
  open: boolean;
  onOpen: () => void;
  onClose: () => void;
}

export const HuduConnectionDrawer = ({
  open,
  onOpen,
  onClose,
}: HuduDrawerProps) => {
  const navigate = useNavigate();

  const { data: huduAuthConfig } = useGetHuduAuthConfig();
  const [apiKey, setApiKey] = useState(huduAuthConfig?.data?.api_key || "");
  const [accountUrl, setAccountUrl] = useState("");
  const [errorMessage, setErrorMessage] = useState("");

  const {
    mutateAsync: upsertHuduAuthConfig,
    isLoading: isUpsertHuduAuthConfigLoading,
  } = useUpsertHuduAuthConfig();

  useEffect(() => {
    setApiKey(
      huduAuthConfig?.data?.has_api_key ? "abcdefghijklmnopqrstuvwx" : "",
    );
    setAccountUrl(huduAuthConfig?.data?.hudu_url || "");
  }, [huduAuthConfig]);

  const companyName = useGlobalStore((state) => state.companyName);

  const onConnectNow = async () => {
    if (apiKey) {
      try {
        if (apiKey) {
          const normalizedUrl = accountUrl.trim().endsWith("/")
            ? accountUrl.trim()
            : `${accountUrl.trim()}/`;
          await upsertHuduAuthConfig({
            msp_name: companyName || "",
            hudu_url: normalizedUrl,
            hudu_api_key: apiKey,
          });
          // add logic to trigger mixpanel name only for create
          addMixpanelEvent({
            event: "hudu_connection_success",
          });
          toast.success("Hudu account connected successfully");
          navigate("/app/control-center/integrations/hudu");
        }
      } catch (error) {
        // @ts-ignore
        const apiErrorMessage = error?.message;
        const formattedErrorMessage = apiErrorMessage?.startsWith(
          "Hudu API connectivity test failed:",
        )
          ? "Invalid Account URL or API key"
          : "Failed to connect Hudu account";
        toast.error(formattedErrorMessage);
      }
    } else {
      setErrorMessage("API key is required");
    }
  };

  return (
    <Drawer
      title="Connect Hudu"
      onClose={() => {
        if (!isUpsertHuduAuthConfigLoading) {
          onClose();
          setApiKey(
            huduAuthConfig?.data?.has_api_key ? "abcdefghijklmnopqrstuvwx" : "",
          );
          setAccountUrl(huduAuthConfig?.data?.hudu_url || "");
        }
      }}
      onOpen={onOpen}
      open={open}
      drawerStyle={{
        width: "680px",
      }}
      primaryButtonText="Connect to Hudu"
      secondaryButtonText="Close"
      onPrimaryButtonClick={onConnectNow}
      onSecondaryButtonClick={onClose}
      primaryButtonSx={{
        display: !huduAuthConfig?.data?.has_api_key ? "flex" : "none",
      }}
      isLoading={isUpsertHuduAuthConfigLoading}
    >
      <ConnectHuduAccount
        apiKey={apiKey}
        setApiKey={setApiKey}
        accountUrl={accountUrl}
        setAccountUrl={setAccountUrl}
        upsertHuduAuthConfig={upsertHuduAuthConfig}
        isUpsertHuduAuthConfigLoading={isUpsertHuduAuthConfigLoading}
        errorMessage={errorMessage}
        setErrorMessage={setErrorMessage}
      />
    </Drawer>
  );
};
